export default __webpack_public_path__ + "static/media/checkMark2.aac8cc56.webp";